import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";

const BankEntryPOPUP = ({ banks = [], loanNames = [], onAdd }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ amount: "", bank_name: "", name: "", type: "Cash Deposit" });

  const reset = () => setForm({ amount: "", bank_name: "", name: "", type: "Cash Deposit" });

  const submit = async () => {
    if (!form.amount || !form.bank_name) return;
    const token = localStorage.getItem("authToken");
    try {
      await axios.post(`${API_BASE_URL}/api/loansave`, {
        token,
        amount: form.amount,
        type: form.type,
        bank_name: form.bank_name,
        name: form.name,
      }, { headers: { "Content-Type": "application/json" } });
      onAdd && onAdd({ ...form });
      reset();
      setOpen(false);
    } catch (e) {
      // fallback: still add locally so the user sees it
      onAdd && onAdd({ ...form });
      reset();
      setOpen(false);
    }
  };

  return (
    <>
      <button type="button" className="btn btn-warning" onClick={() => setOpen(true)}>
        Add Bank Entry
      </button>
      {open && (
        <div className="modal d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Bank Entry</h5>
                <button type="button" className="close" onClick={() => setOpen(false)}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Amount</label>
                  <input type="number" className="form-control" value={form.amount} onChange={(e)=>setForm({...form, amount:e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Bank</label>
                  <input list="be-bank-suggestions" type="text" className="form-control" value={form.bank_name} onChange={(e)=>setForm({...form, bank_name:e.target.value})} />
                  <datalist id="be-bank-suggestions">
                    {banks.map((i,idx)=>(<option key={idx} value={i.name} />))}
                  </datalist>
                </div>
                <div className="form-group">
                  <label>Name (optional)</label>
                  <input list="be-loan-suggestions" type="text" className="form-control" value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})} />
                  <datalist id="be-loan-suggestions">
                    {loanNames.map((i,idx)=>(<option key={idx} value={i.name} />))}
                  </datalist>
                </div>
                <div className="form-group">
                  <label>Type</label>
                  <select className="form-control" value={form.type} onChange={(e)=>setForm({...form, type:e.target.value})}>
                    <option>Cash Deposit</option>
                    <option>RTGS IN</option>
                    <option>RTGS OUT</option>
                    <option>Charges</option>
                    <option>Payment</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setOpen(false)}>Close</button>
                <button type="button" className="btn btn-primary" onClick={submit}>Add</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BankEntryPOPUP;
